import { createTheme } from "@mui/material/styles";

declare module "@mui/material/styles" {
  interface Palette {
    custom: typeof customPalette;
  }

  interface PaletteOptions {
    custom?: typeof customPalette;
  }
}

export const fontFamily = {
  popins: '"Poppins", sans-serif',
  dosis: '"Dosis", sans-serif',
  inter: '"Inter", sans-serif',
};

const customPalette = {
  mainBlue: "#2a85ff",
  mainBlack: "#000",
  mainWhite: "#fff",
  mainBlueDisable: "#8bc5f4",
  blueGray900: "#2a2d31",
  blueGray800: "#383c40",
  blueGray700: "#52575d",
  blueGray600: "#7d8690",
  blueGray500: "#9da6b0",
  blueGray400: "#c6cace",
  blueGray300: "#d5d8db",
  blueGray200: "#e4e7e9",
  blueGray100: "#f4f5f6",
  blueGray50: "#fbfbfb",
  secondaryRed: "#ce212b",
  secondaryGreen: "#008001",
  secondaryGreenLight: "#75b976",
};

const theme = createTheme({
  palette: {
    primary: {
      main: customPalette.mainBlue,
    },
    // secondary: {
    //   main: customPalette.secondaryGreen,
    // },
    error: {
      main: customPalette.secondaryRed,
    },
    background: {
      default: customPalette.mainWhite,
      paper: customPalette.blueGray100,
    },
    text: {
      primary: customPalette.blueGray900,
      secondary: customPalette.blueGray600,
    },

    custom: customPalette,
  },

  components: {
    MuiInputBase: {
      defaultProps: {
        inputProps: {
          spellCheck: "true",
        },
      },
    },
    MuiTextField: {
      defaultProps: {
        spellCheck: "true",
      },
    },
  },

  typography: {
    fontFamily: fontFamily.inter,
    h1: {
      fontSize: "2.375rem", //38px
    },
    h2: {
      fontSize: "1.75rem", //28px
    },
    subtitle1: {
      fontSize: "1.5rem", //24px
    },
    subtitle2: {
      fontSize: "1.375rem", //22px
    },
    h3: {
      fontSize: "1.25rem", //20px
    },
    h4: {
      fontSize: "1.125rem", //18px
    },
    h5: {
      fontSize: "1rem", //16px
    },
    h6: {
      fontSize: "0.875rem", //14px
    },
    body1: {
      fontSize: "0.75rem", //12px
    },
    body2: {
      fontSize: "0.625rem", //10px
    },
  },
});

export default theme;
